



























































































































































































import Vue from "vue";
import store, { BankRemitStore } from "../services/BankRemitStore";
import { formatDate } from "../../../utils/formatDates";
import BankRemitAnalitics from "./BankRemitAnalitcsView.vue";
import MoneyDisplay from "../../../components/MoneyDisplay.vue";
import auth from "@/services/auth";
import BankRemitRemark from "./BankRemitRemark.vue";
import BankRemitItem from "../models/BankRemitItem";
import dayjs from "dayjs";
import Resizer from "../components/Resizer.vue";
import { t } from "@/plugins/i18n";

interface Data {
  store: BankRemitStore;
}

interface Methods {
  formatDate(date: string): string;
  approve(): void;
  createApproval(): void;
  setDeleteItem(item: BankRemitItem): void;
  cancelDelete(item: BankRemitItem): void;
  confirmDelete(item: BankRemitItem): void;
}

export default Vue.extend<Data, Methods, {}, {}>({
  components: {
    BankRemitAnalitics,
    MoneyDisplay,
    BankRemitRemark,
    Resizer,
  },

  data() {
    return {
      store,
    };
  },

  async beforeMount() {
    await this.store.loadResizerPosition();

    this.store.step = 3;

    console.log(this.store.bankRemit.items);
  },

  methods: {
    async confirmDelete(item: BankRemitItem) {
      item.deleting = false;
      item.expanded = false;
      await this.store.deleteItem(item.itemId);
      await this.store.loadBankRemit(Number(this.$route.params.id));
    },

    cancelDelete(item: BankRemitItem) {
      item.deleting = false;
      item.expanded = false;
      this.store.bankRemit.items = [...this.store.bankRemit.items];
    },

    setDeleteItem(item: BankRemitItem) {
      item.deleting = true;
      item.expanded = true;
      this.store.bankRemit.items = [...this.store.bankRemit.items];
    },

    async createApproval() {
      await this.store.loadApproval(Number(this.$route.params.id));
    },

    async approve() {
      await this.store.approve();
      await this.store.loadApproval(Number(this.$route.params.id));
    },

    formatDate(date: string) {
      return formatDate(date);
    },
  },

  computed: {
    isValid(){
      return store.bankRemit.items.every(x => x.bankAccount > 1);
    },

    isApproved() {
      if (
        new Date(dayjs(this.store.bankRemitApproval.accDate).toDate()).getTime() >
        new Date("2000-01-01T00:00:00").getTime()
      ) {
        return true;
      }
      return false;
    },

    isApprover() {
      if (this.store.bankRemitApproval) {
        const x = this.store.allApproverUser.find(
          (x) => x.id == this.store.bankRemitApproval.acceptorId
        );
        if (x && x.name == auth.userName) {
          return true;
        } else return false;
      } else return false;
    },

    itemColumns: () => [
      { field: "prefix", title: t("Prefix"), width: 60 },
      { field: "invoice", title: t("Szamla") },
      { field: "invNo", title: t("BizonylatSzam") },
      {
        field: "partnerName",
        title: t("Partner"),
      },
      {
        field: "amount",
        title: t("SzamlaOsszege"),
        cell: "amountTemplate",
        headerClassName: "right_text",
        className: "right_text",
      },
      {
        field: "exchangeRate",
        title: t("Arfolyamszorzo"),
        headerClassName: "right_text",
        className: "right_text",
      },
      {
        title: t("UtalasiHatarido"),
        field: "pterm",
        type: "date",
        format: "{0: yyyy. MM. dd.}",
        className: "center_text",
        headerClassName: "center_text",
        width: 150,
      },
      {
        cell: "errorTemplate",
        width: 60,
      },
      {
        cell: "commandTemplate",
        width: 60,
      },
      { width: 0, filterable: false },
    ],
  },
});
